import React, { useState } from "react"; // 🚨 쓰지 않는 useEffect, useParams 제거
import styles from './EditBoxMemo.module.css';
import { useTranslation } from 'react-i18next';

// props 대신 구조 분해 할당을 사용하여 직관적으로 만듭니다.
function EditBoxMemo({ onSubmit, onClose }) {
    const { t } = useTranslation();
    const [memo, setMemo] = useState('');

    const handleSave = () => {
        onSubmit(memo);
        onClose();
    };

    return (
        // 🚨 기존 코드에 있던 중복된 modalBackground 태그 1개를 제거했습니다.
        <div className={styles.modalBackground} onClick={(e) => e.target === e.currentTarget && onClose()}>
            {/* 이벤트 버블링(클릭 퍼짐)을 막아주는 stopPropagation은 유지합니다. */}
            <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
                <div className={styles.editMemoTitle}>
                    {/* ★ 'Edit memo' 부분도 언어팩(다국어)이 적용되도록 수정했습니다. */}
                    {t('Edit memo')}
                </div>
                <textarea
                    placeholder={t('Please write a new memo')}
                    className={styles.editMemoTextArea}
                    value={memo}
                    onChange={(e) => setMemo(e.target.value)}
                />
                <div className={styles.editMemoSaveButton}>
                    <div className={styles.saveButton} onClick={handleSave}>
                        {t('Save')}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditBoxMemo;